import { createFileRoute } from "@tanstack/react-router";

const Route = createFileRoute("/$pillar/$category/")({ component: () => null });

export { Route };
